import React, { createContext, useContext, useState } from 'react';

/**
 * UserContext - контекст для хранения данных пользователя
 * Используется для передачи email пользователя между компонентами
 */
const UserContext = createContext(null);

/**
 * UserProvider - провайдер контекста пользователя
 * Оборачивает приложение и предоставляет доступ к userEmail
 */
export const UserProvider = ({ children }) => {
  const [userEmail, setUserEmail] = useState(null);

  return (
    <UserContext.Provider value={{ userEmail, setUserEmail }}>
      {children}
    </UserContext.Provider>
  );
};

/**
 * useUser - хук для доступа к данным пользователя
 * Использование: const { userEmail, setUserEmail } = useUser();
 */
export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};

export default UserContext;
